import { pb } from "@/lib/pb";
import type { Worker } from "./model";

/**
 * Reads go straight to the collections: every org member reads every machine,
 * and Flows categories and cards are the viewer's own. The one write is
 * `/api/workers/configure` (pb/pb_hooks/workers-lib.js), for org writers.
 */

export function fetchWorkers(signal?: AbortSignal): Promise<Worker[]> {
  return pb.collection("workers").getFullList<Worker>({ requestKey: null, signal, sort: "name,key" });
}

/** The viewer's queued cards, only the category of each: the node cards count them. */
export function fetchQueuedCards(signal?: AbortSignal): Promise<{ id: string; category: string }[]> {
  return pb.collection("flow_cards").getFullList<{ id: string; category: string }>({
    requestKey: null,
    signal,
    filter: "status = 'queued'",
    fields: "id,category",
  });
}

export type ConfigureInput = { key: string; name?: string; role?: string; categories?: string[] };

export function configureWorker(input: ConfigureInput): Promise<unknown> {
  return pb.send("/api/workers/configure", { method: "POST", body: input, requestKey: null });
}
